import { z } from 'zod/v4';
import { TableViewFilterSchema } from './table-view-filter';
export const GetRowCountInputSchema = z.object({
    tableViewId: z.string(),
    filters: z.array(TableViewFilterSchema).nullish(),
});
export const GetRowCountOutputSchema = z.object({
    rowCount: z.number(),
});
//# sourceMappingURL=get-row-count.js.map